import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container mw-1356" }
const _hoisted_2 = { class: "coupon-wrap" }
const _hoisted_3 = { class: "row align-items-center" }
const _hoisted_4 = { class: "col-lg-6 col-sm-6 mb-3 mb-sm-0" }
const _hoisted_5 = { class: "ptb-100" }
const _hoisted_6 = { class: "total-cart" }
const _hoisted_7 = { class: "d-flex justify-content-between" }
const _hoisted_8 = { class: "price" }
const _hoisted_9 = { class: "d-flex justify-content-between" }
const _hoisted_10 = { class: "price" }
const _hoisted_11 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_RouterLink, {
            to: "/products",
            class: "read-more style-two"
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createElementVNode("i", { class: "ti ti-arrow-left" }, null, -1),
              _createTextVNode(" Back To Shop ", -1)
            ]))]),
            _: 1
          })
        ]),
        _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"col-lg-6 col-sm-6\"><div class=\"position-relative z-1\"><input type=\"text\" class=\"form-control bg-white w-100\" placeholder=\"Coupon Code\"><button type=\"submit\" class=\"btn position-absolute top-50 end-0 translate-middle-y\"><span class=\"border-style\">Apply</span></button></div></div>", 1))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _cache[5] || (_cache[5] = _createElementVNode("h3", null, "Cart Totals", -1)),
        _createElementVNode("ul", null, [
          _createElementVNode("li", _hoisted_7, [
            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "title" }, "Subtotal", -1)),
            _createElementVNode("span", _hoisted_8, "$" + _toDisplayString(_ctx.cartStore.totalPrice.toFixed(2)), 1)
          ]),
          _createElementVNode("li", _hoisted_9, [
            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "title" }, "Total", -1)),
            _createElementVNode("span", _hoisted_10, "$" + _toDisplayString(_ctx.cartStore.totalPrice.toFixed(2)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_RouterLink, {
            to: "/checkout",
            class: "btn"
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createElementVNode("span", { class: "border-style" }, "Proceed To Checkout", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}